module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/train-class-dialog/train-class-dialog.component.scss
// module id = 1538
// module chunks = 0